export function generateSecurePassword(length = 16) {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const symbols = "!@#$%&*_+.?";

  const all = upper + lower + numbers + symbols;

  const getRandomChar = (charset) => {
    const randomValues = new Uint32Array(1);
    window.crypto.getRandomValues(randomValues);
    return charset[randomValues[0] % charset.length];
  };

  let password = "";

  // Ensure at least one character from each category
  password += getRandomChar(upper);
  password += getRandomChar(lower);
  password += getRandomChar(numbers);
  password += getRandomChar(symbols);

  // Fill the rest
  for (let i = password.length; i < length; i++) {
    password += getRandomChar(all);
  }

  // Shuffle password (Fisher-Yates)
  const passwordArray = password.split("");
  for (let i = passwordArray.length - 1; i > 0; i--) {
    const randomValues = new Uint32Array(1);
    window.crypto.getRandomValues(randomValues);
    const j = randomValues[0] % (i + 1);
    [passwordArray[i], passwordArray[j]] = [
      passwordArray[j],
      passwordArray[i],
    ];
  }

  return passwordArray.join("");
}